import { call } from "redux-saga/effects";

import { PhotoUploadStatus } from "@/mk2/helpers/form.reducers";
import { tupdate } from "@/mk2/helpers/types";
import { ACTIVE_SERVER_ID } from "@/mk/settings";
import { forum_api_post_create_url } from "@/mk/urls/functions";

export const CONVERT_TO_DISCUSSION_ENABLED_IN_GROUPS = false;
export const DEFAULT_TOPIC_ID = { 201: 806, 202: 540 }[ACTIVE_SERVER_ID];

export function generateDiscussionTitleAndPerex(perex: string): { title: string; perex: string } {
    if (perex.length < 100) {
        // Krátky text - všetko do title, perex prázdny
        return { title: perex, perex: "" };
    } else {
        // Dlhý text - prvá veta do title, celý text do perex
        const firstSentence = perex.match(/^.*?[.?!]/)?.[0].trim() ?? perex.trim();
        return { title: firstSentence, perex: perex };
    }
}

interface ApiResponseForumPostCreate {
    body: {
        post: any;
        postIsRemovedFromFeeds: boolean;
        notificationsOn: number[];
    };
}

export function* createForumThread({
    postFd,
    xhr,
}: {
    postFd: any;
    xhr: any;
}): Generator<any, any, any> {
    const { title, perex } = generateDiscussionTitleAndPerex(postFd.perex);
    const response: ApiResponseForumPostCreate = yield call(() =>
        xhr.post(forum_api_post_create_url(), {
            topicId: DEFAULT_TOPIC_ID,
            anonymousMode: false,
            postData: tupdate(postFd, {
                title,
                perex,
                photos: postFd.photos
                    ? postFd.photos.filter((photo) => photo.status === PhotoUploadStatus.SUCCESS)
                    : [],
            }),
        }),
    );

    return response;
}
